import Glide from "@glidejs/glide";

const processStepsSliderHandler = () => {
	const processSliders = document.querySelectorAll(".process-table__glide");

	processSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "slider",
				startAt: 0,
				perView: 3,
				autoplay: Number(autoplay),
				gap: 30,
				bound: true,
				peek: { before: 0, after: 100 },
				breakpoints: {
					800: {
						perView: 2,
					},
					640: {
						perView: 1,
						gap: 10,
						peek: 0,
					},
				},
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});
};

if (document.readyState !== "loading") {
	processStepsSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", processStepsSliderHandler);
}
